export const INITIALIZE = 'INITIALIZE'
export const SAVE_PREFERENCES = 'SAVE_PREFERENCES'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE'
export const READ_MESSAGES = 'READ_MESSAGES'
